var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSms = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sms"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7 3.25H17C18.7301 3.25 20.0268 3.74555 20.8906 4.60938C21.7544 5.4732 22.25 6.76991 22.25 8.5V15.5C22.25 17.2301 21.7544 18.5268 20.8906 19.3906C20.0268 20.2544 18.7301 20.75 17 20.75H7C5.26991 20.75 3.9732 20.2544 3.10938 19.3906C2.24555 18.5268 1.75 17.2301 1.75 15.5V8.5C1.75 6.76991 2.24555 5.4732 3.10938 4.60938C3.9732 3.74555 5.26991 3.25 7 3.25ZM7 3.75C5.49651 3.75 4.28283 4.11561 3.44922 4.94922C2.61561 5.78283 2.25 6.99651 2.25 8.5V15.5C2.25 17.0035 2.61561 18.2172 3.44922 19.0508C4.28283 19.8844 5.49651 20.25 7 20.25H17C18.5035 20.25 19.7172 19.8844 20.5508 19.0508C21.3844 18.2172 21.75 17.0035 21.75 15.5V8.5C21.75 6.99651 21.3844 5.78283 20.5508 4.94922C19.7172 4.11561 18.5035 3.75 17 3.75H7Z",
    fill: "#9C4FFF",
    stroke: "#9C4FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.8447 8.79785C16.9523 8.71046 17.1078 8.73462 17.1816 8.83203L17.1914 8.8457C17.2787 8.95322 17.2555 9.10784 17.1582 9.18164L17.1475 9.18945L14.0176 11.6895L14.0107 11.6953C13.4746 12.1391 12.7431 12.3701 12 12.3701C11.2575 12.3701 10.5236 12.1392 9.97559 11.6924L9.97168 11.6895L6.8418 9.18945C6.72835 9.09457 6.72163 8.93981 6.79785 8.8457C6.89255 8.72915 7.04958 8.72076 7.14453 8.79785L7.14746 8.80078L10.2773 11.3008C10.7619 11.6894 11.3914 11.8672 11.9951 11.8672C12.5987 11.8671 13.2275 11.6892 13.7119 11.3008L16.8418 8.80078L16.8447 8.79785Z",
    fill: "#9C4FFF",
    stroke: "#9C4FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0,
    d: "M23.5 0.5V23.5H0.5V0.5H23.5Z",
    stroke: "#9C4FFF"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSms);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sms.fcec87dae33c4757303078a70323abdb.svg";